import { render, staticRenderFns } from "./CreateTaxonomyTable.vue?vue&type=template&id=07716456&"
import script from "./CreateTaxonomyTable.vue?vue&type=script&lang=js&"
export * from "./CreateTaxonomyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports